import axios, { AxiosResponse } from "axios";
import { CreateLeitnerBoxDTO } from "../../models/dtos/content/leitner/CreateLeitnerBoxDTO";
import { LeitnerBoxInformationDTO } from "../../models/dtos/content/leitner/LeitnerBoxInformationDTO";
import { LeitnerBoxsDTO } from "../../models/dtos/content/leitner/LeitnerBoxsDTO";
import { LeitnerBoxQueryString } from "../../models/query-strings/content/leitner/LeitnerBoxQueryString";
import BaseService from "../base/BaseService";

export default class LearningBoxService extends BaseService {
    create(createLeitnerBoxDTO: CreateLeitnerBoxDTO): Promise<any> {
        return axios.post(`/LearningBox`, createLeitnerBoxDTO)
            .then(function (response: AxiosResponse<any, any>) {
                return response.data;
            });
    }

    getPaged(leitnerBoxQueryString: LeitnerBoxQueryString): Promise<LeitnerBoxsDTO[]> {
        return axios.get(`/LearningBox`, { params: leitnerBoxQueryString })
            .then(function (response: AxiosResponse<LeitnerBoxsDTO[], any>) {
                return response.data;
            });
    }

    getInformationById(boxId: string): Promise<LeitnerBoxInformationDTO> {
        return axios.get(`/LearningBox/${boxId}`)
            .then(function (response: AxiosResponse<LeitnerBoxInformationDTO, any>) {
                return response.data;
            });
    }

    delete(boxId: string): Promise<any> {
        return axios.delete(`/LearningBox/${boxId}`).then(function (response: any) { return response.data;});
    }
}